import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Search  from './search';
import SearchResult  from './searchResult';
import Context from '../context/Context';
import searchStyles from '../styles/SearchStyles.module.scss';

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    paper: {
        width: 350,
        margin: '16px',
        textAlign: 'left'
    },
    SearchResultpaper: {
        width: 350,
        // margin: theme.spacing(2),
        margin: 0,
        textAlign: 'left',
        padding: 0
    }
});

class SideNav extends Component {
    
    render() {
        return (
            <Context.Consumer>
                {context => (
            <div className={searchStyles.sideNav}>
                        {/* <Paper className={classes.paper} style={{boxShadow:"none"}}> */}
                            <Search dcList={context.dcNbrList} selectedSavedSearch={context.selectedSavedSearch} showHideSidenav={context.showHideSidenav} ref={this.props.resetReference} />
                        {/* </Paper> */}
                        
                        {context.searchResult && context.searchResult.length > 0 && <SearchResult />}
                        {/* <>  */}
                        {/* <Paper className={classes.SearchResultpaper} style={{boxShadow:"none", marginLeft:"0px"}}> */}
                           
                        {/* </Paper> */}
                        {/* <Paper className={classes.paper} style={{boxShadow:"none"}}>
                            <BulkDownload/>
                        </Paper> */}
                       {/* </>} */}
            </div>)}
            </Context.Consumer>
            
        );
    }
}
SideNav.contextType = Context;

SideNav.propTypes = {
  resetReference: PropTypes.object
};

export default withStyles(styles)(SideNav);